// extracted by mini-css-extract-plugin
export default {"strategySlider":"index_strategySlider__G65uQ"};